import { type NotificationStatusEnumEnum } from '@/shared/api'
import { type PresetColorType } from 'antd/es/_util/colors'

export const NotificationStatusTypeEnum = {
  Planned: 0 as NotificationStatusEnumEnum,
  Sent: 1 as NotificationStatusEnumEnum,
  Error: 2 as NotificationStatusEnumEnum,
} as const

export type NotificationStatusTypeEnum =
  (typeof NotificationStatusTypeEnum)[keyof typeof NotificationStatusTypeEnum]

export const notificationStatusTypeArray = Object.values(
  NotificationStatusTypeEnum,
)

export const getNotificationStatusTypeString = (
  type: NotificationStatusTypeEnum,
) => {
  switch (type) {
    case NotificationStatusTypeEnum.Planned:
      return 'Запланировано'
    case NotificationStatusTypeEnum.Sent:
      return 'Отправлено'
    case NotificationStatusTypeEnum.Error:
      return 'Ошибка'
    default:
      return 'Неизвестный тип'
  }
}

export const getNotificationStatusTypeColorString = (
  type: NotificationStatusTypeEnum,
): PresetColorType => {
  switch (type) {
    case NotificationStatusTypeEnum.Planned:
      return 'yellow'
    case NotificationStatusTypeEnum.Sent:
      return 'green'
    case NotificationStatusTypeEnum.Error:
      return 'red'
    default:
      return 'cyan'
  }
}
